import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactFab from "@/components/ContactFab";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-paper">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ContactFab />
      <Toaster richColors position="top-right" />
    </div>
  );
}
